import ConnectionHandler from 'relay-connection-handler-plus';
import { Environment, Network, RecordSource, Store } from 'relay-runtime';

import fetchGraphQL from './fetchGraphQL';

// Relay passes a "params" object with the query name and text. So we define a helper function
// to call our fetchGraphQL utility with params.text.
async function fetchRelay(params: any, variables: any) {
  return fetchGraphQL(params.text, variables, params.name);
}

function handlerProvider(handle: string) {
  switch (handle) {
    case 'connection':
      return ConnectionHandler;
    default:
      throw new Error(`no handler configured for ${handle}`);
  }
}

// Export a singleton instance of Relay Environment configured with our network function:
const modernEnvironment: Environment = new Environment({
  network: Network.create(fetchRelay),
  store: new Store(new RecordSource(), {
    // This property tells Relay to not immediately clear its cache when the user
    // navigates around the app. Relay will hold onto the specified number of
    // query results, allowing the user to return to recently visited pages
    // and reusing cached data if its available/fresh.
    gcReleaseBufferSize: 10,
  }),
  // This connection handler exposes an additional getConnections method
  // https://github.com/relay-tools/relay-connection-handler-plus
  handlerProvider,
});

export default modernEnvironment;
